/*! Vaultiqe Date Code Checker 1.0.0 (2026-10-25). Generiert von werkzeuge/build.mjs. Quelle: Vaultiqe/06_Automation/date-code-checker. */
/*!
* Vaultiqe — Louis Vuitton Date Code Checker, Prüfkern (ohne DOM).
* Läuft im Browser (window.VQDCC) und in Node (require) für die Tests.
* Die Regeln stehen in daten/regeln.json, die Kürzel in daten/fabriken.json.
* Der Kern urteilt nie über Echtheit. Er sagt nur, ob ein Code als Format stimmig ist.
*/
(function (root, factory) {
if (typeof module === 'object' && module.exports) module.exports = factory();
else root.VQDCC = factory();
}(typeof self !== 'undefined' ? self : this, function () {
'use strict';
var DIGIT_LOOKALIKE = { O: '0', Q: '0', D: '0', U: '0', I: '1', L: '1', J: '1', T: '1', Z: '2', S: '5', B: '8', G: '6', A: '4' };
var LETTER_LOOKALIKE = { '0': 'O', '1': 'I', '2': 'Z', '5': 'S', '6': 'G', '8': 'B', '4': 'A' };
var PREFIX_RE = /^(LOUIS\s*VUITTON|LV|DATE\s*-?\s*CODE|DATECODE|DATA\s*-?\s*CODE|DATACODE|SERIAL(\s*NUMBER)?|SERIENNUMMER|SERIAL\s*NO|CODE)\b[\s:#.\-]*/;
var NR_RE = /^NR[.:#]\s*/;
var COUNTRY_WORD = { FRANCE: 'FR', USA: 'US', 'U.S.A.': 'US', 'U.S.A': 'US', SPAIN: 'ES', ESPANA: 'ES', ITALY: 'IT', ITALIA: 'IT', GERMANY: 'DE', SWITZERLAND: 'CH', SUISSE: 'CH', BELGIUM: 'BE' };
function pad2(n) { return (n < 10 ? '0' : '') + n; }
function normalize(raw) {
var original = String(raw == null ? '' : raw);
var s = original;
if (s.normalize) s = s.normalize('NFKC');
s = s.toUpperCase().trim();
var guard = 0;
while ((PREFIX_RE.test(s) || NR_RE.test(s)) && guard++ < 3) s = s.replace(PREFIX_RE, '').replace(NR_RE, '');
var madeIn = null, mm = /MADE\s*IN\s*(?:THE\s*)?([A-Z.]+)/.exec(s);
if (mm) { madeIn = COUNTRY_WORD[mm[1]] || COUNTRY_WORD[mm[1].replace(/\./g, '')] || ('?' + mm[1].replace(/\./g, '')); s = s.replace(/MADE\s*IN\s*(?:THE\s*)?[A-Z.]+/, ' '); }
s = s.replace(/LOUIS\s*VUITTON|PARIS|®/g, ' ');
var clean = s.replace(/[^A-Z0-9]+/g, '');
return { original: original, clean: clean, separators: clean.length !== s.replace(/\s+/g, '').length || /\s/.test(s), madeIn: madeIn };
}
function isoWeekRange(year, week) {
var jan4 = new Date(Date.UTC(year, 0, 4));
var dow = jan4.getUTCDay() || 7;
var mondayW1 = new Date(jan4.getTime() - (dow - 1) * 86400000);
var start = new Date(mondayW1.getTime() + (week - 1) * 7 * 86400000);
var end = new Date(start.getTime() + 6 * 86400000);
return { start: start.toISOString().slice(0, 10), end: end.toISOString().slice(0, 10) };
}
function isoWeeksInYear(year) {
var d = new Date(Date.UTC(year, 11, 28));
var dow = d.getUTCDay() || 7;
var thursday = new Date(d.getTime() + (4 - dow) * 86400000);
var jan1 = new Date(Date.UTC(thursday.getUTCFullYear(), 0, 1));
return Math.ceil(((thursday - jan1) / 86400000 + 1) / 7);
}
function yearFrom2(yy, rules) {
return yy >= 80 ? 1900 + yy : 2000 + yy;
}
function factoryInfo(data, code) {
var f = data.factories && data.factories[code];
if (!f) return { code: code, known: false };
return { code: code, known: true, countries: f.c || [], weak: f.w || [], grade: f.g || 'B', note: f.n || null, win: f.win || null, repair: !!f.repair };
}
function part(chars, role, value) { return { chars: chars, role: role, value: value }; }
/* ---------- Lesarten ---------- */
function readEarly80s(digits, rules) {
var yy = +digits.slice(0, 2), m = +digits.slice(2);
var ok = yy >= rules.early80s.yyMin && yy <= rules.early80s.yyMax && m >= 1 && m <= 12;
return {
era: 'e80a', format: digits.length === 3 ? 'YYM' : 'YYMM', valid: ok, unitRaw: digits.slice(2), yearRaw: digits.slice(0, 2),
problem: ok ? null : (m < 1 || m > 12 ? 'month_range_80s' : 'year_range_80s'),
year: 1900 + yy, month: m, factory: null,
parts: [part(digits.slice(0, 2), 'year', 1900 + yy), part(digits.slice(2), 'month', m)]
};
}
function readLate80s(letters, digits, order, rules) {
var yy = +digits.slice(0, 2), m = +digits.slice(2);
var ok = yy >= rules.late80s.yyMin && yy <= rules.late80s.yyMax && m >= 1 && m <= 12;
var p = [part(letters, 'factory', letters), part(digits.slice(0, 2), 'year', 1900 + yy), part(digits.slice(2), 'month', m)];
if (order === 'digits_first') p = [p[1], p[2], p[0]];
return {
era: 'e80b', format: (order === 'digits_first' ? (digits.length === 3 ? 'YYMLL' : 'YYMMLL') : (digits.length === 3 ? 'LLYYM' : 'LLYYMM')),
valid: ok, problem: ok ? null : (yy < rules.late80s.yyMin || yy > rules.late80s.yyMax ? 'year_range_80s' : 'month_range_80s'),
unitRaw: digits.slice(2), yearRaw: digits.slice(0, 2),
year: 1900 + yy, month: m, factoryCode: letters, parts: p
};
}
function readModern(letters, digits, rules) {
var a = digits.charAt(0), b = digits.charAt(1), c = digits.charAt(2), d = digits.charAt(3);
var yy = +(b + d), unit = +(a + c);
var year = yearFrom2(yy, rules);
var parts = [
part(letters, 'factory', letters),
part(a, 'unit1', null), part(b, 'year1', null), part(c, 'unit2', null), part(d, 'year2', null)
];
var r = { factoryCode: letters, year: year, parts: parts, yy: yy, unitRaw: a + c, yearRaw: b + d };
if (year >= rules.monthEra.from && year <= rules.monthEra.to) {
r.era = 'e90'; r.format = 'LL M Y M Y'; r.month = unit;
r.valid = unit >= 1 && unit <= 12; r.problem = r.valid ? null : 'month_range';
parts[1].role = 'month1'; parts[3].role = 'month2'; parts[2].role = 'year1'; parts[4].role = 'year2';
} else if (year >= rules.weekEra.from && year <= rules.weekEra.to) {
r.era = 'e07'; r.format = 'LL W Y W Y'; r.week = unit;
var maxW = rules.weekEra.allowWeek53 ? 53 : 52;
r.valid = unit >= 1 && unit <= maxW; r.problem = r.valid ? null : 'week_range';
if (r.valid && !(unit === 53 && isoWeeksInYear(year) < 53)) r.range = isoWeekRange(year, unit);
parts[1].role = 'week1'; parts[3].role = 'week2'; parts[2].role = 'year1'; parts[4].role = 'year2';
} else if (rules.weekEra.transitionalTo && year > rules.weekEra.to && year <= rules.weekEra.transitionalTo) {
r.era = 'e07'; r.format = 'LL W Y W Y'; r.week = unit;
r.valid = unit >= 1 && unit <= 53; r.problem = r.valid ? null : 'week_range';
r.softFlag = 'after_chip_switch';
if (r.valid && !(unit === 53 && isoWeeksInYear(year) < 53)) r.range = isoWeekRange(year, unit);
parts[1].role = 'week1'; parts[3].role = 'week2'; parts[2].role = 'year1'; parts[4].role = 'year2';
} else {
r.era = 'none'; r.format = 'LL????'; r.valid = false;
r.problem = year > rules.weekEra.to && year <= 2029 ? 'year_after_chip' : 'year_range';
}
if (r.valid && r.week === 53) {
var wk = isoWeeksInYear(year) < 53 ? 'week53_non_iso' : 'week53';
r.softFlag = r.softFlag ? [].concat(r.softFlag, wk) : wk;
}
return r;
}
/* ---------- Hauptanalyse ---------- */
function interpret(clean, data) {
var rules = data.rules;
var readings = [];
var m;
if (!clean) return { kind: 'empty' };
if ((m = /^([MN])(\d{5})([A-Z]?)$/.exec(clean))) return { kind: 'model_number', modelNumber: clean };
if (/^Z\d{4}[A-Z]?$/.test(clean)) return { kind: 'not_a_date_code', reason: 'sunglasses_ref' };
if (/^Q[A-Z0-9]{4,6}$/.test(clean) && /\d{3}/.test(clean)) return { kind: 'not_a_date_code', reason: 'watch_ref' };
if (/^1A[0-9A-Z]{4}$/.test(clean) || /^R\d{5}$/.test(clean)) return { kind: 'not_a_date_code', reason: 'product_ref' };
if (/^AAS\d{4,5}$/.test(clean)) return { kind: 'special', reason: 'special_order', factory: factoryInfo(data, 'AAS') };
if (/^\d{7,}$/.test(clean) || clean.length >= 10) return { kind: 'not_a_date_code', reason: 'too_long' };
if (/^[A-Z]{1,3}$/.test(clean)) {
var fi = factoryInfo(data, clean);
return { kind: 'incomplete', reason: 'letters_only', factory: fi.known ? fi : null };
}
if (/^8\d0$/.test(clean) || /^[A-Z]{2}8\d0$/.test(clean) || /^8\d0[A-Z]{2}$/.test(clean)) return { kind: 'incomplete', reason: 'worn_digit' };
if ((m = /^(\d{3,4})$/.exec(clean))) {
var e = readEarly80s(m[1], rules);
if (e.valid) readings.push(e);
if (m[1].length === 4) readings.push({ era: 'missing_letters', valid: false, problem: 'missing_letters' });
if (!e.valid && m[1].length === 3) readings.push({ era: 'missing_letters', valid: false, problem: 'missing_letters' });
return { kind: 'readings', readings: readings };
}
if ((m = /^(\d{3,4})([A-Z]{2})$/.exec(clean))) {
var r1 = readLate80s(m[2], m[1], 'digits_first', rules);
readings.push(r1);
if (m[1].length === 4) {
var rev = readModern(m[2], m[1], rules);
if (rev.valid) { rev.reversed = true; readings.push(rev); }
}
return { kind: 'readings', readings: readings };
}
if ((m = /^(\d{3,4})([A-Z]\d)$/.exec(clean)) && data.factories && data.factories[m[2]]) {
readings.push(readLate80s(m[2], m[1], 'digits_first', rules));
return { kind: 'readings', readings: readings };
}
if ((m = /^([A-Z]\d)(\d{4})$/.exec(clean)) && data.factories && data.factories[m[1]]) {
readings.push(readModern(m[1], m[2], rules));
return { kind: 'readings', readings: readings };
}
if ((m = /^([A-Z]{3})(\d{4})$/.exec(clean))) {
if (data.factories && data.factories[m[1]]) { readings.push(readModern(m[1], m[2], rules)); return { kind: 'readings', readings: readings }; }
return { kind: 'unrecognized', reason: 'three_letters' };
}
if ((m = /^([A-Z]{2})(\d{3})$/.exec(clean))) {
var r3 = readLate80s(m[1], m[2], 'letters_first', rules);
if (r3.valid) readings.push(r3);
else readings.push({ era: 'missing_digit', valid: false, problem: 'missing_digit', factoryCode: m[1] });
return { kind: 'readings', readings: readings };
}
if ((m = /^([A-Z]{2})(\d{4})$/.exec(clean))) {
var L = m[1], D = m[2];
if (D.charAt(0) === '8') {
var r4 = readLate80s(L, D, 'letters_first', rules);
readings.push(r4);
return { kind: 'readings', readings: readings };
}
var mod = readModern(L, D, rules);
readings.push(mod);
if (rules.allow1990Unlaced && D.slice(0, 2) === '90') {
var mm = +D.slice(2);
if (mm >= 1 && mm <= 12) readings.push({ era: 'e80b', format: 'LLYYMM', valid: true, year: 1990, month: mm, factoryCode: L, rare: true,
parts: [part(L, 'factory', L), part('90', 'year', 1990), part(D.slice(2), 'month', mm)] });
}
return { kind: 'readings', readings: readings };
}
if (/^[A-Z]\d{4}$/.test(clean)) return { kind: 'incomplete', reason: 'one_letter' };
if (/^[A-Z]{1,2}\d{1,2}$/.test(clean) || /^\d{1,2}$/.test(clean)) return { kind: 'incomplete', reason: 'short' };
if (/^[A-Z]{2}\d{5,6}$/.test(clean)) return { kind: 'unrecognized', reason: 'too_many_digits' };
return { kind: 'unrecognized', reason: 'pattern' };
}
function lookalikeVariants(clean, limit) {
var out = {}, list = [];
function add(s) { if (s !== clean && !out[s]) { out[s] = 1; list.push(s); } }
if (clean.length < 3 || clean.length > 8) return list;
var chars = clean.split('');
var letterPart = chars.slice(0, 2).map(function (ch) { return /\d/.test(ch) && LETTER_LOOKALIKE[ch] ? LETTER_LOOKALIKE[ch] : ch; });
var digitPart = chars.slice(2).map(function (ch) { return /[A-Z]/.test(ch) && DIGIT_LOOKALIKE[ch] ? DIGIT_LOOKALIKE[ch] : ch; });
add(letterPart.join('') + digitPart.join(''));
add(chars.slice(0, 2).join('') + digitPart.join(''));
add(letterPart.join('') + chars.slice(2).join(''));
add(chars.map(function (ch) { return /[A-Z]/.test(ch) && DIGIT_LOOKALIKE[ch] ? DIGIT_LOOKALIKE[ch] : ch; }).join(''));
return list.slice(0, limit || 6);
}
function attachFactory(reading, data) {
if (reading.factoryCode) reading.factory = factoryInfo(data, reading.factoryCode);
return reading;
}
function contextChecks(reading, data, ctx) {
var flags = [];
if (!ctx || !reading || !reading.valid) return flags;
if (ctx.model) {
var mdl = null;
for (var i = 0; i < (data.models || []).length; i++) if (data.models[i].id === ctx.model) { mdl = data.models[i]; break; }
if (mdl && mdl.intro && reading.year < mdl.intro) {
if (mdl.introMin && reading.year < mdl.introMin) flags.push({ key: 'year_before_model', model: mdl.name, intro: mdl.introMin, year: reading.year });
else if (reading.year === mdl.intro - 1) flags.push({ key: 'year_just_before_model', model: mdl.name, intro: mdl.intro, year: reading.year });
else flags.push({ key: mdl.introSure ? 'year_before_model' : 'year_before_model_weak', model: mdl.name, intro: mdl.intro, year: reading.year });
}
if (mdl && mdl.end && reading.year > mdl.end + 1) flags.push({ key: 'year_after_model', model: mdl.name, end: mdl.end, year: reading.year });
if (mdl && mdl.noCode) flags.push({ key: mdl.noCodeKey || 'model_usually_no_code', model: mdl.name });
if (mdl && mdl.largeBag && afterChip(reading)) flags.push({ key: 'chip_era_bag', model: mdl.name, year: reading.year });
}
var f = reading.factory;
if (ctx.madeIn && f && f.known) {
if (ctx.madeIn.charAt(0) === '?') flags.push({ key: 'country_unknown', madeIn: ctx.madeIn.slice(1) });
else if (f.repair) flags.push({ key: 'repair_code' });
else if (f.countries.indexOf(ctx.madeIn) !== -1) { /* passt */ }
else if (f.weak && f.weak.indexOf(ctx.madeIn) !== -1) flags.push({ key: 'country_weak', madeIn: ctx.madeIn, countries: f.countries });
else flags.push({ key: 'country_mismatch', madeIn: ctx.madeIn, countries: f.countries });
}
return flags;
}
function afterChip(r) {
return r && r.valid && (r.year > 2021 || (r.year === 2021 && r.week && r.week >= 14));
}
function factoryFlags(reading) {
var flags = [], f = reading && reading.factory;
if (reading && reading.valid && reading.year === 2021 && reading.week >= 14) flags.push({ key: 'late_2021', week: reading.week });
if (reading && reading.valid && reading.year < 1982) flags.push({ key: 'before_1982', year: reading.year });
if (!f || !f.known || !reading.valid) return flags;
if (f.win && ((f.win.from && reading.year < f.win.from) || (f.win.to && reading.year > f.win.to))) {
flags.push({ key: f.win.from && reading.year < f.win.from ? 'before_window' : 'after_window', code: f.code, from: f.win.from, to: f.win.to, year: reading.year });
}
return flags;
}
var SOFT = { before_window: 1, after_window: 1, country_weak: 1, week53: 1, after_chip_switch: 1, reversed_order: 1, repair_code: 1, late_2021: 1, shoe_code: 1, model_usually_no_code: 1, not_for_category: 1, before_1982: 1, year_just_before_model: 1, year_before_model_weak: 1, repair_digits: 1 };
function analyze(raw, data, ctx, noSuggest) {
var n = normalize(raw);
if (n.madeIn && !(ctx && ctx.madeIn)) ctx = Object.assign({}, ctx || {}, { madeIn: n.madeIn, madeInFromText: true });
var res = { input: n.original, clean: n.clean, normalizedChanged: n.clean !== n.original.trim().toUpperCase(), madeInText: n.madeIn };
if (!n.clean && n.original.trim()) { res.kind = res.status = 'not_a_date_code'; res.reason = 'stamp_text'; res.madeInDetected = n.madeIn || null; return res; }
var it = interpret(n.clean, data);
res.kind = it.kind;
if (it.kind !== 'readings') {
res.status = it.kind;
res.reason = it.reason || null;
if (it.factory) res.factory = it.factory;
if (it.modelNumber) res.modelNumber = it.modelNumber;
if (it.kind === 'unrecognized' || it.kind === 'incomplete') res.suggestions = noSuggest ? [] : suggestions(n.clean, data);
return res;
}
var readings = it.readings.map(function (r) { return attachFactory(r, data); });
var valid = readings.filter(function (r) { return r.valid; });
res.readings = readings;
if (!valid.length) {
var hint = readings[0] || {};
if (hint.problem === 'missing_letters' || hint.problem === 'missing_digit') {
res.status = 'incomplete'; res.reason = hint.problem;
} else if (hint.factory && hint.factory.repair) {
res.status = 'special'; res.reason = 'repair'; res.factory = hint.factory;
} else {
res.status = 'impossible'; res.reason = hint.problem || 'pattern';
}
res.primary = readings[0] || null;
res.suggestions = noSuggest ? [] : suggestions(n.clean, data);
return res;
}
var main = valid.filter(function (r) { return !r.rare && !r.reversed; });
var primary = main[0] || valid[0];
res.primary = primary;
res.alternatives = valid.filter(function (r) { return r !== primary; });
res.flags = contextChecks(primary, data, ctx).concat(factoryFlags(primary));
[].concat(primary.softFlag || []).forEach(function (k) { res.flags.push({ key: k, year: primary.year, week: primary.week }); });
if (primary.reversed) res.flags.push({ key: 'reversed_order' });
if (primary.rare) res.flags.push({ key: 'unlaced_1990', month: primary.month });
if (res.flags.some(function (x) { return x.key === 'chip_era_bag'; })) res.flags = res.flags.filter(function (x) { return x.key !== 'late_2021' && x.key !== 'after_chip_switch'; });
var f = primary.factory;
if (f && !f.known && !noSuggest) res.suggestions = letterSuggestions(n.clean, primary, data).filter(function (v) { return analyze(v, data, null, true).status === 'consistent'; });
res.madeInDetected = n.madeIn || null;
var hard = res.flags.filter(function (x) { return x.key === 'year_before_model' || x.key === 'year_after_model' || x.key === 'country_mismatch' || x.key === 'country_unknown' || x.key === 'chip_era_bag'; });
if (hard.length) res.status = 'contradiction';
else if (main.length > 1 || primary.rare) res.status = 'inconclusive';
else if (f && !f.known) res.status = 'unknown_factory';
else if (f && (f.grade === 'C' || f.grade === 'D')) res.status = 'consistent_note';
else if (res.flags.some(function (x) { return SOFT[x.key]; })) res.status = 'consistent_note';
else res.status = 'consistent';
return res;
}
var LETTER_CONFUSE = { I: ['L', 'T', 'J'], L: ['I'], T: ['I'], J: ['I'], O: ['D', 'Q', 'C'], D: ['O'], Q: ['O'], C: ['G', 'O'], G: ['C'], U: ['V'], V: ['U', 'Y'], Y: ['V'], M: ['N', 'H'], N: ['M', 'H'], H: ['N', 'M'], E: ['F'], F: ['E', 'P'], P: ['F', 'R'], R: ['P', 'B'], B: ['R', '8'], K: ['X'], X: ['K'] };
function letterSuggestions(clean, reading, data) {
var fc = reading.factoryCode || '';
if (!fc || !data.factories) return [];
var idx = clean.indexOf(fc);
if (idx < 0) return [];
var out = [];
for (var i = 0; i < fc.length; i++) {
var alts = LETTER_CONFUSE[fc.charAt(i)] || [];
for (var j = 0; j < alts.length; j++) {
var cand = fc.slice(0, i) + alts[j] + fc.slice(i + 1);
if (data.factories[cand]) {
var whole = clean.slice(0, idx) + cand + clean.slice(idx + fc.length);
if (out.indexOf(whole) === -1) out.push(whole);
}
}
}
return out.slice(0, 3);
}
var WORN = { '3': ['8'], '8': ['3', '6'], '1': ['7'], '7': ['1'], '0': ['9', '2', '8'], '9': ['0'], '2': ['0'], '6': ['5', '8'], '5': ['6'] };
function wornVariants(clean) {
var m = /^([A-Z]{2}|A[0-2])(\d{4})$/.exec(clean), out = [];
if (!m) return out;
for (var i = 0; i < 4; i++) {
var alts = WORN[m[2].charAt(i)] || [];
for (var j = 0; j < alts.length; j++) out.push(m[1] + m[2].slice(0, i) + alts[j] + m[2].slice(i + 1));
}
return out;
}
function suggestions(clean, data) {
var all = suggestionsRaw(clean, data);
return all.filter(function (v) { return analyze(v, data, null, true).status === 'consistent'; }).slice(0, 3);
}
function suggestionsRaw(clean, data) {
var out = [];
var worn = [];
wornVariants(clean).forEach(function (v) {
var it = interpret(v, data);
if (it.kind === 'readings' && it.readings.some(function (r) { return r.valid && !r.rare && r.year <= 2021 && data.factories && data.factories[r.factoryCode]; })) worn.push(v);
});
if (worn.length && worn.length <= 2) out = out.concat(worn);
lookalikeVariants(clean, 8).forEach(function (v) {
var it = interpret(v, data);
if (it.kind !== 'readings') return;
var ok = it.readings.some(function (r) { return r.valid && (!r.factoryCode || (data.factories && data.factories[r.factoryCode])); });
if (ok && out.indexOf(v) === -1) out.push(v);
});
return out.slice(0, 3);
}
return {
version: '1.0.0',
normalize: normalize,
analyze: analyze,
isoWeekRange: isoWeekRange,
isoWeeksInYear: isoWeeksInYear,
_interpret: interpret,
_lookalikeVariants: lookalikeVariants,
pad2: pad2
};
}));
window.VQDCC_DATA={"v":"1.0.0","rules":{"early80s":{"yyMin":80,"yyMax":89},"late80s":{"yyMin":80,"yyMax":89},"monthEra":{"from":1990,"to":2006},"weekEra":{"from":2007,"to":2021,"allowWeek53":true,"transitionalTo":2025},"allow1990Unlaced":true},"factories":{"A0":{"c":["FR"],"g":"A"},"A1":{"c":["FR"],"g":"A"},"A2":{"c":["FR"],"g":"A"},"AA":{"c":["FR"],"g":"A"},"AAS":{"c":["FR"],"g":"A"},"AC":{"c":["ES","FR"],"g":"B"},"AH":{"c":["FR"],"g":"A"},"AI":{"c":["FR"],"g":"D"},"AL":{"c":["FR"],"g":"D"},"AN":{"c":["FR"],"g":"A"},"AO":{"c":["FR","IT"],"g":"D"},"AR":{"c":["FR"],"g":"A","w":["IT"]},"AS":{"c":["FR"],"g":"A"},"AX":{"c":["FR"],"g":"B"},"BA":{"c":["FR","IT"],"g":"A","w":["ES"]},"BC":{"c":["IT","ES","FR"],"g":"A"},"BE":{"c":["FR"],"g":"B","win":{"from":2019}},"BI":{"c":["IT"],"g":"C"},"BJ":{"c":["FR"],"g":"A"},"BM":{"c":["IT"],"g":"C"},"BO":{"c":["IT"],"g":"A"},"BP":{"c":["ES"],"g":"B"},"BR":{"c":["IT"],"g":"C"},"BU":{"c":["FR"],"g":"A"},"CA":{"c":["ES"],"g":"A","w":["FR"]},"CE":{"c":["IT"],"g":"A"},"CH":{"c":["CH"],"g":"D"},"CI":{"c":["FR"],"g":"C"},"CL":{"c":["IT"],"g":"C"},"CO":{"c":["FR"],"g":"A","w":["ES"]},"CP":{"c":["IT"],"g":"C"},"CR":{"c":["ES"],"g":"B"},"CT":{"c":["FR"],"g":"A"},"CV":{"c":["FR"],"g":"B"},"CX":{"c":["FR"],"g":"A","w":["IT"]},"DE":{"c":["IT"],"g":"C"},"DF":{"c":["IT"],"g":"C"},"DI":{"c":["CH"],"g":"A","w":["IT"]},"DK":{"c":["FR"],"g":"A","repair":true},"DP":{"c":["IT"],"g":"C"},"DR":{"c":["FR"],"g":"A","w":["IT"]},"DT":{"c":["FR"],"g":"A","w":["US"]},"DU":{"c":["FR"],"g":"A"},"EA":{"c":["IT"],"g":"C"},"EL":{"c":["IT"],"g":"C"},"ET":{"c":["FR"],"g":"A"},"FA":{"c":["CH","IT"],"g":"A","w":["FR"]},"FC":{"c":["US"],"g":"A"},"FD":{"c":["IT"],"g":"C"},"FF":{"c":["US"],"g":"C"},"FH":{"c":["US","IT"],"g":"A","w":["FR"]},"FJ":{"c":["IT"],"g":"C"},"FK":{"c":["IT"],"g":"B","win":{"from":2019}},"FL":{"c":["FR","US"],"g":"A"},"FN":{"c":["IT"],"g":"A","win":{"from":2019}},"FO":{"c":["IT"],"g":"A"},"FP":{"c":["IT"],"g":"A","win":{"from":2019}},"FR":{"c":["FR"],"g":"D"},"FW":{"c":["IT"],"g":"C"},"FX":{"c":["IT"],"g":"B"},"FY":{"c":["IT"],"g":"B"},"FZ":{"c":["IT"],"g":"B","win":{"from":2019}},"GI":{"c":["ES"],"g":"A","w":["IT"]},"GM":{"c":["IT"],"g":"C"},"GO":{"c":["IT"],"g":"B"},"GR":{"c":["FR"],"g":"B"},"IL":{"c":["IT"],"g":"C"},"IS":{"c":["IT"],"g":"C"},"IT":{"c":["FR"],"g":"D"},"JA":{"c":["IT","BE"],"g":"C"},"JG":{"c":["ES"],"g":"C"},"JJ":{"c":["ES"],"g":"A"},"LA":{"c":["FR","US"],"g":"A"},"LB":{"c":["ES"],"g":"A","w":["FR"]},"LE":{"c":["IT"],"g":"B"},"LI":{"c":["IT"],"g":"C"},"LK":{"c":["IT"],"g":"C"},"LM":{"c":["ES","FR"],"g":"A"},"LO":{"c":["ES"],"g":"A","w":["FR"]},"LP":{"c":["DE"],"g":"A"},"LU":{"c":["FR"],"g":"B","win":{"from":2019}},"LW":{"c":["FR","ES"],"g":"A"},"LY":{"c":["FR"],"g":"B","win":{"from":2019}},"MA":{"c":["IT"],"g":"A"},"MB":{"c":["FR"],"g":"A"},"MI":{"c":["FR"],"g":"A"},"ML":{"c":["FR"],"g":"B","win":{"from":2019}},"MM":{"c":["FR"],"g":"B","win":{"from":2019}},"MO":{"c":["FR","ES"],"g":"C"},"MR":{"c":["IT"],"g":"C"},"MS":{"c":["FR","IT"],"g":"A"},"MT":{"c":["IT"],"g":"C"},"MX":{"c":["FR"],"g":"C"},"ND":{"c":["FR","IT"],"g":"D"},"NL":{"c":["IT"],"g":"C"},"NO":{"c":["FR"],"g":"A"},"NQ":{"c":["IT"],"g":"B"},"NZ":{"c":["IT"],"g":"A"},"OB":{"c":["IT"],"g":"A"},"OK":{"c":["US"],"g":"C","repair":true},"OL":{"c":["DE"],"g":"A"},"OS":{"c":["US"],"g":"A","w":["FR"]},"OU":{"c":["FR"],"g":"C"},"PB":{"c":["DE"],"g":"C"},"PL":{"c":["IT"],"g":"A"},"PO":{"c":["DE"],"g":"C"},"PT":{"c":["FR"],"g":"C"},"RA":{"c":["FR"],"g":"A"},"RC":{"c":["IT"],"g":"A"},"RE":{"c":["IT","FR"],"g":"A"},"RI":{"c":["FR"],"g":"A"},"RJ":{"c":["FR"],"g":"C"},"RO":{"c":["IT"],"g":"B"},"RT":{"c":["IT"],"g":"C"},"SA":{"c":["FR","IT"],"g":"A"},"SC":{"c":["IT"],"g":"C"},"SD":{"c":["FR","US"],"g":"A"},"SF":{"c":["FR"],"g":"A"},"SK":{"c":["FR"],"g":"B"},"SL":{"c":["FR"],"g":"A"},"SN":{"c":["FR"],"g":"A"},"SP":{"c":["FR"],"g":"A","w":["ES"]},"SR":{"c":["FR"],"g":"A"},"ST":{"c":["IT"],"g":"B"},"TA":{"c":["FR"],"g":"A"},"TB":{"c":["IT"],"g":"A","win":{"from":2019}},"TC":{"c":["CH","IT"],"g":"D"},"TD":{"c":["IT"],"g":"A"},"TE":{"c":["IT"],"g":"C"},"TH":{"c":["FR"],"g":"A","w":["IT"]},"TJ":{"c":["FR"],"g":"A"},"TN":{"c":["FR"],"g":"A"},"TO":{"c":["CH"],"g":"C"},"TR":{"c":["FR"],"g":"A"},"TS":{"c":["FR"],"g":"A"},"TX":{"c":["US"],"g":"A","win":{"from":2017}},"TY":{"c":["FR"],"g":"A","w":["IT"],"win":{"from":2019}},"UB":{"c":["ES"],"g":"A"},"US":{"c":["IT"],"g":"C"},"VI":{"c":["FR"],"g":"A","win":{"to":2011}},"VM":{"c":["FR"],"g":"B"},"VR":{"c":["FR"],"g":"C"},"VT":{"c":["FR"],"g":"C"},"VX":{"c":["FR"],"g":"A"},"WL":{"c":["FR"],"g":"B"}},"countries":{"FR":{"de":"Frankreich","en":"France"},"US":{"de":"USA","en":"USA"},"ES":{"de":"Spanien","en":"Spain"},"IT":{"de":"Italien","en":"Italy"},"DE":{"de":"Deutschland","en":"Germany"},"CH":{"de":"Schweiz","en":"Switzerland"},"BE":{"de":"Belgien","en":"Belgium"}},"madeInOptions":["FR","US","ES","IT","DE","CH","BE"],"models":[{"id":"speedy","name":"Speedy","group":"bags","largeBag":true,"hasLoc":true},{"id":"neverfull","name":"Neverfull","group":"bags","intro":2007,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"alma","name":"Alma","group":"bags","largeBag":true,"hasLoc":true},{"id":"pochette-metis","name":"Pochette Métis","group":"bags","intro":2012,"largeBag":true,"introMin":2011,"hasLoc":true},{"id":"pochette-accessoires","name":"Pochette Accessoires","group":"bags","hasLoc":true},{"id":"mini-pochette-accessoires","name":"Mini Pochette Accessoires","group":"slg","hasLoc":true},{"id":"multi-pochette-accessoires","name":"Multi Pochette Accessoires","group":"bags","intro":2019,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"favorite","name":"Favorite","group":"bags","intro":2012,"largeBag":true,"introMin":2005,"hasLoc":true},{"id":"keepall","name":"Keepall","group":"travel","largeBag":true,"hasLoc":true},{"id":"noe","name":"Noé","group":"bags","largeBag":true,"hasLoc":true},{"id":"neonoe","name":"NéoNoé","group":"bags","intro":2017,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"palm-springs","name":"Palm Springs","group":"bags","intro":2015,"largeBag":true,"hasLoc":true},{"id":"artsy","name":"Artsy","group":"bags","intro":2010,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"galliera","name":"Galliera","group":"bags","intro":2008,"largeBag":true,"introMin":2007,"hasLoc":true},{"id":"onthego","name":"OnTheGo","group":"bags","intro":2019,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"capucines","name":"Capucines","group":"bags","intro":2013,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"twist","name":"Twist","group":"bags","intro":2014,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"musette","name":"Musette","group":"bags","largeBag":true,"hasLoc":true},{"id":"papillon","name":"Papillon","group":"bags","largeBag":true,"hasLoc":true},{"id":"bumbag","name":"Bumbag","group":"bags","intro":2018,"introSure":true,"hasLoc":true},{"id":"bucket","name":"Bucket","group":"bags","largeBag":true,"hasLoc":true},{"id":"cabas-piano","name":"Cabas Piano","group":"bags","largeBag":true},{"id":"keepall-bandouliere","name":"Keepall Bandoulière","group":"travel","largeBag":true,"hasLoc":true},{"id":"toiletry-26","name":"Toiletry Pouch 26","group":"slg","hasLoc":true},{"id":"zippy-wallet","name":"Zippy Wallet","group":"slg","hasLoc":true},{"id":"wallet","name":"Andere Geldbörsen (Sarah, Victorine …)","group":"slg","hasLoc":true},{"id":"pochette-cles","name":"Pochette Clés","group":"slg","hasLoc":true},{"id":"belt","name":"Gürtel","group":"other","hasLoc":true},{"id":"shoes","name":"Schuhe","group":"other","noCode":true,"noCodeKey":"shoe_code","hasLoc":true},{"id":"sunglasses","name":"Sonnenbrille","group":"other","noCode":true,"noCodeKey":"not_for_category","hasLoc":true},{"id":"watch","name":"Uhr","group":"other","noCode":true,"noCodeKey":"not_for_category","hasLoc":true},{"id":"trunk","name":"Koffer und Truhen (Hartschale)","group":"other","hasLoc":true},{"id":"speedy-bandouliere","name":"Speedy Bandoulière","group":"bags","intro":2011,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"alma-bb","name":"Alma BB","group":"bags","intro":2010,"largeBag":true,"hasLoc":true},{"id":"pochette-felicie","name":"Pochette Félicie","group":"slg","intro":2015,"introSure":true,"hasLoc":true},{"id":"eva","name":"Eva","group":"bags","intro":2008,"largeBag":true,"introMin":2007,"hasLoc":true},{"id":"delightful","name":"Delightful","group":"bags","intro":2010,"largeBag":true,"introMin":2007,"hasLoc":true},{"id":"totally","name":"Totally","group":"bags","intro":2009,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"graceful","name":"Graceful","group":"bags","intro":2017,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"boite-chapeau-souple","name":"Boîte Chapeau Souple","group":"bags","intro":2018,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"petite-malle","name":"Petite Malle","group":"bags","intro":2014,"largeBag":true,"introSure":true,"hasLoc":true},{"id":"montaigne","name":"Montaigne","group":"bags","intro":2013,"largeBag":true,"introMin":2012,"hasLoc":true},{"id":"hampstead","name":"Hampstead","group":"bags","largeBag":true,"hasLoc":true}]};
/*!
* Vaultiqe — Louis Vuitton Date Code Checker, Oberfläche als Web-Komponente <vq-date-code-checker>.
* Erwartet window.VQDCC (Prüfkern), window.VQDCC_DATA (Regeln + Kürzel) und window.VQDCC_I18N (Texte).
* Fortschreitende Verbesserung: Das Formular funktioniert auch ohne JavaScript (GET ?code=…).
*/
(function () {
'use strict';
if (typeof window === 'undefined' || !window.customElements || customElements.get('vq-date-code-checker')) return;
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
function fmt(tpl, p) {
return String(tpl || '').replace(/\{(\w+)\}/g, function (_, k) { return p && p[k] != null ? p[k] : ''; });
}
function publish(name, payload) {
try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, payload || {}); } catch (e) { /* Messung darf nie die Seite stören */ }
}
class VqDateCodeChecker extends HTMLElement {
connectedCallback() {
if (this._ready) return;
this._ready = true;
var lang = (this.getAttribute('data-lang') || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
var all = window.VQDCC_I18N || {};
this.t = all[lang] || all.en || {};
this.lang = all[lang] ? lang : 'en';
this.data = window.VQDCC_DATA;
this.engine = window.VQDCC;
if (!this.data || !this.engine) return;
this.form = this.querySelector('form');
this.input = this.querySelector('input[name="code"]');
var page = (this.closest && this.closest('.vqp')) || document;
this.out = this.querySelector('[data-dcc-result]') || page.querySelector('[data-dcc-result]');
this.modelSel = this.querySelector('select[name="model"]');
this.madeSel = this.querySelector('select[name="made_in"]');
this.locBox = this.querySelector('[data-dcc-location]');
this.noCodeBtn = this.querySelector('[data-dcc-nocode]');
this.noCodePanel = this.querySelector('[data-dcc-nocode-panel]');
if (!this.form || !this.input || !this.out) return;
var hero = this.closest ? this.closest('.vq-dcc-hero') : null;
this.spec = hero ? hero.querySelector('[data-dcc-specimen]') : null;
if (this.spec) this.specInit = { code: this.spec.querySelector('[data-spec-code]').textContent, legend: this.spec.querySelector('[data-spec-legend]').innerHTML, caption: this.spec.querySelector('[data-spec-caption]').textContent };
this.dial = hero ? hero.querySelector('.vq-dcc-dial') : null;
if (this.dial) {
var dd = this.dial, init = { texts: {} };
['factory', 'country', 'year', 'unit', 'range', 'caption', 'text'].forEach(function (k) { init.texts[k] = dd.querySelector('[data-dial-' + k + ']').textContent; });
init.arc = dd.querySelector('[data-dial-arc]').getAttribute('style');
init.pointer = dd.querySelector('[data-dial-pointer]').style.transform;
var on = dd.querySelector('.vq-dcc-dial__month.is-on');
init.month = on ? +on.getAttribute('data-dial-month') : -1;
this.dialInit = init;
var selfF = this; this.dialFit();
if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { selfF.dialFit(); });
}
this.fillSelects();
this.crossSummary = this.querySelector('[data-dcc-cross-summary]');
var self = this;
this.form.addEventListener('submit', function (e) {
e.preventDefault(); self.run(true);
var wide = window.matchMedia && window.matchMedia('(min-width: 900px)').matches;
var tool = self.querySelector('.vq-dcc__tool');
if (wide || !tool || self.out.hidden) return;
var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
self.input.blur();
setTimeout(function () { try { tool.scrollIntoView({ block: 'start', behavior: still ? 'auto' : 'smooth' }); } catch (err) { tool.scrollIntoView(true); } }, 80);
});
this.input.addEventListener('input', function () { self.schedule(); });
if (this.modelSel) this.modelSel.addEventListener('change', function () { self.showLocation(); self.updateCross(); self.run(false); });
if (this.madeSel) this.madeSel.addEventListener('change', function () { self.updateCross(); self.run(false); });
[].forEach.call(this.querySelectorAll('dialog.vq-dcc-sheet'), function (dlg) {
dlg.addEventListener('click', function (e) { if (e.target === dlg || (e.target.closest && e.target.closest('[data-dcc-close]'))) self.closeSheet(dlg); });
dlg.addEventListener('cancel', function (e) { e.preventDefault(); self.closeSheet(dlg); });
});
var crossBtn = this.querySelector('[data-dcc-open="cross"]'), crossDlg = this.querySelector('[data-dcc-sheet="cross"]');
if (crossBtn && crossDlg) crossBtn.addEventListener('click', function () { self.openSheet(crossDlg); publish('vq_dcc_action', { action: 'cross_open' }); });
var resetBtn = this.querySelector('[data-dcc-reset]');
if (resetBtn) resetBtn.addEventListener('click', function () { if (self.modelSel) self.modelSel.value = ''; if (self.madeSel) self.madeSel.value = ''; self.showLocation(); self.updateCross(); self.run(false); });
if (this.noCodeBtn && this.noCodePanel) {
this.noCodeBtn.addEventListener('click', function () { self.toggleNoCode(); });
}
this.out.addEventListener('click', function (e) { self.onAction(e); });
var detailsLink = this.dial && this.dial.querySelector('[data-dial-link]');
if (detailsLink) detailsLink.addEventListener('click', function (e) {
if (!self.out || self.out.hidden) return;
e.preventDefault();
self.glide(self.out);
});
[].forEach.call(page.querySelectorAll('.vq-dcc-toc a[href^="#"], .vq-dcc-content a[href^="#"], .vq-dcc__foot a[href^="#"]'), function (a) {
a.addEventListener('click', function (e) {
var id = decodeURIComponent(a.getAttribute('href').slice(1)), el = id && document.getElementById(id);
if (!el) return;
e.preventDefault();
self.glide(el);
if (window.history && history.replaceState) history.replaceState(null, '', '#' + id);
});
});
if (this.noCodePanel) this.noCodePanel.addEventListener('change', function () { self.renderNoCode(); });
var params = new URLSearchParams(location.search);
if (params.get('model') && this.modelSel) { this.modelSel.value = params.get('model'); this.showLocation(); }
if (params.get('made_in') && this.madeSel) this.madeSel.value = params.get('made_in');
this.updateCross();
if (params.get('code')) { this.input.value = params.get('code'); this.run(false); }
this.setAttribute('data-enhanced', '');
var selfR = this;
if (window.requestAnimationFrame) window.requestAnimationFrame(function () { selfR.holdDialReveal(); }); else this.holdDialReveal();
}
fillSelects() {
var t = this.t, d = this.data, lang = this.lang;
if (this.modelSel && this.modelSel.options.length <= 1) {
var groups = {};
(d.models || []).forEach(function (m) { (groups[m.group || 'bags'] = groups[m.group || 'bags'] || []).push(m); });
var html = '<option value="">' + esc(t.modelNone) + '</option>';
Object.keys(groups).forEach(function (g) {
html += '<optgroup label="' + esc((t.modelGroups || {})[g] || g) + '">';
groups[g].forEach(function (m) { html += '<option value="' + esc(m.id) + '">' + esc((t.modelNames || {})[m.id] || m.name) + '</option>'; });
html += '</optgroup>';
});
this.modelSel.innerHTML = html;
}
if (this.madeSel && this.madeSel.options.length <= 1) {
var h = '<option value="">' + esc(t.madeInNone) + '</option>';
(d.madeInOptions || []).forEach(function (c) { h += '<option value="' + c + '">' + esc((d.countries[c] || {})[lang] || c) + '</option>'; });
this.madeSel.innerHTML = h;
}
}
schedule() {
var self = this;
clearTimeout(this._t);
this._t = setTimeout(function () { self.run(false); }, 90);
clearTimeout(this._pub);
}
ctx() {
return { model: this.modelSel && this.modelSel.value || null, madeIn: this.madeSel && this.madeSel.value || null };
}
run(explicit) {
var raw = this.input.value;
var res = this.engine.analyze(raw, this.data, this.ctx());
this.last = res;
if (res.madeInDetected && res.madeInDetected.charAt(0) !== '?' && this.madeSel && !this.madeSel.value) { this.madeSel.value = res.madeInDetected; }
this.render(res);
if (explicit) this.syncUrl(res);
var self = this;
clearTimeout(this._pub);
if (res.status !== 'empty') {
this._pub = setTimeout(function () {
publish('vq_dcc_check', {
status: res.status, era: res.primary && res.primary.era || null,
factory: res.primary && res.primary.factoryCode || null,
has_model: !!self.ctx().model, has_made_in: !!self.ctx().madeIn, explicit: !!explicit
});
}, explicit ? 0 : 1500);
}
}
syncUrl(res) {
if (window.Shopify && Shopify.designMode) return;
try {
var p = new URLSearchParams(location.search);
if (res.clean) p.set('code', res.clean); else p.delete('code');
var c = this.ctx();
if (c.model) p.set('model', c.model); else p.delete('model');
if (c.madeIn) p.set('made_in', c.madeIn); else p.delete('made_in');
var q = p.toString();
history.replaceState(history.state, '', location.pathname + (q ? '?' + q : '') + location.hash);
} catch (e) { /* ältere Browser */ }
}
showLocation() {
if (!this.locBox || !this.modelSel) return;
var id = this.modelSel.value, t = this.t, lang = this.lang, mdl = null;
(this.data.models || []).forEach(function (m) { if (m.id === id) mdl = m; });
var locText = mdl && (t.modelLoc || {})[mdl.id];
if (!mdl || !locText) { this.locBox.hidden = true; this.locBox.innerHTML = ''; return; }
this.locBox.hidden = false;
this.locBox.innerHTML = '<p class="vq-dcc__loc-title">' + esc(fmt(t.locTitle, { model: (t.modelNames || {})[mdl.id] || mdl.name })) + '</p><p>' + esc(locText) + '</p>' +
(mdl.intro ? '<p class="vq-dcc__loc-meta">' + esc(fmt(t.locIntro, { year: mdl.intro })) + '</p>' : '');
}
countryNames(codes) {
var d = this.data, lang = this.lang, t = this.t;
var names = (codes || []).map(function (c) { return (d.countries[c] || {})[lang] || c; });
if (names.length <= 1) return names.join('');
return names.slice(0, -1).join(', ') + ' ' + t.or + ' ' + names[names.length - 1];
}
monthName(m) { return (this.t.months || [])[m - 1] || String(m); }
fmtDate(iso) {
var p = iso.split('-');
return this.lang === 'de' ? (+p[2]) + '. ' + this.monthName(+p[1]) : this.monthName(+p[1]) + ' ' + (+p[2]);
}
headline(r, noRange) {
var t = this.t;
if (r.week) {
var rg = r.range && !noRange ? fmt(t.weekRange, { from: this.fmtDate(r.range.start), to: this.fmtDate(r.range.end) }) : '';
return fmt(t.headWeek, { week: r.week, year: r.year, range: rg });
}
if (r.month) return fmt(t.headMonth, { month: this.monthName(r.month), year: r.year });
return String(r.year || '');
}
placeText(r) {
var f = r.factory;
if (!f) return '';
if (!f.known) return fmt(this.t.placeUnknown, { code: f.code });
return fmt(this.t.placeKnown, { code: f.code, country: this.countryNames(f.countries) });
}
breakdown(r) {
var t = this.t, roles = t.roles || {};
if (!r.parts) return '';
return '<ol class="vq-dcc__parts" role="list" aria-label="' + esc(t.breakdownLabel) + '">' + r.parts.map(function (p) {
var cls = p.role.replace(/\d$/, '');
return '<li class="vq-dcc__part vq-dcc__part--' + cls + '"><span class="vq-dcc__part-chars">' + esc(p.chars) + '</span><span class="vq-dcc__part-role">' + esc(roles[p.role] || p.role) + '</span></li>';
}).join('') + '</ol>';
}
eraLine(r) {
var e = (this.t.eras || {})[r.era];
return e ? '<p class="vq-dcc__era">' + esc(e) + '</p>' : '';
}
flagsHtml(res) {
var t = this.t, self = this;
if (!res.flags || !res.flags.length) return '';
return '<ul class="vq-dcc__flags">' + res.flags.map(function (f) {
var txt = (t.flags || {})[f.key] || f.key;
var p = Object.assign({}, f);
if (f.countries) p.countries = self.countryNames(f.countries);
if (f.madeIn) p.madeIn = (self.data.countries[f.madeIn] || {})[self.lang] || (f.madeIn.charAt(0) + f.madeIn.slice(1).toLowerCase());
return '<li>' + esc(fmt(txt, p)) + '</li>';
}).join('') + '</ul>';
}
bridgeHtml() {
var t = this.t, root = this.getAttribute('data-root') || '';
var id = this.modelSel && this.modelSel.value, name = null;
if (id) (this.data.models || []).forEach(function (m) { if (m.id === id && m.group !== 'other') name = (t.modelNames || {})[m.id] || m.name; });
var label = name ? fmt(t.bridgeLinkModel, { model: name }) : t.bridgeLink;
return '<p class="vq-dcc__bridge">' + esc(t.bridge) + ' <a href="' + esc(root + '/collections/louis-vuitton') + '" data-dcc-cta="result_collection">' + esc(label) + ' →</a></p>';
}
checksHtml(res) {
var t = this.t;
var items = (t.checks || []).slice();
return '<div class="vq-dcc__checks"><p class="vq-dcc__checks-title">' + esc(t.checksTitle) + '</p><ul>' +
items.map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ul></div>';
}
listingText(res) {
var r = res.primary, t = this.t;
if (!r) return '';
var when = this.headline(r);
var place = r.factory && r.factory.known ? this.countryNames(r.factory.countries) : '';
return fmt(place ? t.listing : t.listingNoPlace, { code: res.clean, when: when, place: place });
}
actionsHtml(res) {
var t = this.t;
var html = '<div class="vq-dcc__actions">';
if (res.primary && res.primary.valid) html += '<button type="button" class="vq-dcc__btn" data-dcc-act="copy">' + esc(t.actCopy) + '</button>';
html += '<button type="button" class="vq-dcc__btn" data-dcc-act="share">' + esc(t.actShare) + '</button>';
html += '<a class="vq-dcc__btn vq-dcc__btn--quiet" data-dcc-act="report" href="' + esc(this.reportHref(res)) + '">' + esc(t.actReport) + '</a>';
html += '</div><p class="vq-dcc__toast" role="status" aria-live="polite" hidden></p>';
return html;
}
reportHref(res) {
var t = this.t;
var body = fmt(t.reportBody, { code: res.clean || '', status: res.status || '', url: location.href });
return 'mailto:' + (this.getAttribute('data-report-email') || 'contact@vaultiqe.com') + '?subject=' + encodeURIComponent(fmt(t.reportSubject, { code: res.clean || '' })) + '&body=' + encodeURIComponent(body);
}
suggestionsHtml(res) {
var t = this.t;
if (!res.suggestions || !res.suggestions.length) return '';
return '<p class="vq-dcc__suggest">' + esc(t.suggest) + ' ' + res.suggestions.map(function (s) {
return '<button type="button" class="vq-dcc__chip" data-dcc-act="try" data-code="' + esc(s) + '">' + esc(s) + '</button>';
}).join(' ') + '</p>';
}
specRows(r) {
var t = this.t, s = t.spec || {}, self = this;
var base = function (p) { return p.role.replace(/\d$/, ''); };
return ['factory', r.week ? 'week' : 'month', 'year'].filter(function (g) {
return r.parts.some(function (p) { return base(p) === g; });
}).map(function (g) {
var chars = r.parts.map(function (p) {
var on = base(p) === g;
return p.chars.split('').map(function (ch) { return '<span' + (on ? ' class="on"' : '') + '>' + esc(ch) + '</span>'; }).join('');
}).join('');
var label = g === 'factory' ? (r.factory && r.factory.known ? fmt(s.factory, { code: r.factoryCode, country: self.countryNames(r.factory.countries) }) : fmt(s.factoryUnknown, { code: r.factoryCode }))
: g === 'week' ? fmt(s.week, { week: r.week }) : g === 'month' ? fmt(s.month, { month: (t.months || [])[r.month - 1] }) : fmt(s.year, { year: r.year });
return '<div class="vq-dcc-spec__row"><span class="vq-dcc-spec__chars">' + chars + '</span><span class="vq-dcc-spec__label">' + esc(label) + '</span></div>';
}).join('');
}
glide(el) {
var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
try { el.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' }); } catch (err) { el.scrollIntoView(true); }
if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
try { el.focus({ preventScroll: true }); } catch (err) { /* älterer Browser */ }
}
holdDialReveal() {
var dd = this.dial;
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (!dd || reduce || !('IntersectionObserver' in window) || dd.getBoundingClientRect().top < window.innerHeight * 0.9) return;
dd.classList.add('is-waiting');
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (en) {
if (!en.isIntersecting) return;
io.disconnect();
window.requestAnimationFrame(function () { dd.classList.remove('is-waiting'); });
});
}, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
io.observe(dd);
}
replay(el, cls) {
if (!el) return;
el.classList.remove(cls); void el.getBoundingClientRect(); el.classList.add(cls);
}
dialRange(range) {
var s = this.t.spec || {}, a = range.start.split('-'), b = range.end.split('-');
var d1 = +a[2], d2 = +b[2], m1 = +a[1] - 1, m2 = +b[1] - 1;
if (m1 === m2) return fmt(s.rangeSame, { d1: d1, d2: d2, month: (this.t.months || [])[m1] });
return fmt(s.rangeCross, { d1: d1, d2: d2, m1: (s.monthsAbbr || [])[m1], m2: (s.monthsAbbr || [])[m2] });
}
dialFit() {
var d = this.dial, room = { factory: 140, country: 164, year: 176, unit: 152, range: 128, idle1: 160, idle2: 164 };
Object.keys(room).forEach(function (k) {
var el = d.querySelector('[data-dial-' + k + ']');
if (!el || !el.getComputedTextLength) return;
el.style.fontSize = '';
var w = el.textContent ? el.getComputedTextLength() : 0;
if (w > room[k]) el.style.fontSize = (parseFloat(getComputedStyle(el).fontSize) * room[k] / w).toFixed(2) + 'px';
});
}
dialUpdate(res) {
var d = this.dial;
if (!d) return;
var t = this.t, s = t.spec || {}, r = res.primary, st = res.status;
var q = function (k) { return d.querySelector('[data-dial-' + k + ']'); };
var set = function (k, v) { var el = q(k); if (el.textContent !== v) el.textContent = v; };
var arc = q('arc'), pointer = q('pointer'), verdict = q('verdict'), link = q('link');
var month = function (i) { [].forEach.call(d.querySelectorAll('.vq-dcc-dial__month'), function (m) { m.classList.toggle('is-on', +m.getAttribute('data-dial-month') === i); }); };
if (st === 'empty') {
var init = this.dialInit;
Object.keys(init.texts).forEach(function (k) { set(k, init.texts[k]); });
arc.setAttribute('style', init.arc); pointer.style.transform = init.pointer; pointer.style.opacity = '';
month(init.month); verdict.removeAttribute('data-st'); link.hidden = true;
if (this.dialKey) this.replay(q('textgroup'), 'is-swap');
d.classList.add('is-idle');
this.dialKey = '';
this.dialFit();
return;
}
var code = r && r.parts ? r.parts.map(function (p) { return p.chars; }).join('') : (res.clean || '');
var key = st + '|' + (r && r.valid ? r.year + '-' + (r.week || r.month) + '-' + r.factoryCode : '');
if (key !== this.dialKey) { this.replay(q('textgroup'), 'is-swap'); if (verdict.getAttribute('data-st') !== st) this.replay(verdict, 'is-pop'); }
this.dialKey = key;
d.classList.remove('is-idle');
set('caption', ((t.status || {})[st] || '') + ' · ' + code.slice(0, 10));
set('text', (s.verdict || {})[st] || '');
verdict.setAttribute('data-st', st); link.hidden = false;
var span = r && r.valid ? (r.week ? [(r.week - 1) / 52 * 360, Math.min(360, r.week / 52 * 360)] : r.month ? [(r.month - 1) * 30, r.month * 30] : null) : null;
if (!span) {
set('factory', ''); set('country', ''); set('year', '–'); set('unit', ''); set('range', '');
arc.style.strokeDasharray = '0 360'; pointer.style.transform = 'rotate(0deg)'; month(-1);
this.dialFit();
return;
}
set('factory', r.factoryCode ? fmt(s.factoryShort, { code: r.factoryCode }) : '');
set('country', r.factoryCode ? (r.factory && r.factory.known ? this.countryNames(r.factory.countries) : s.notListed || '') : '');
set('year', String(r.year));
set('unit', r.week ? fmt(s.week, { week: r.week }) : fmt(s.month, { month: (t.months || [])[r.month - 1] }));
set('range', r.week && r.range ? this.dialRange(r.range) : '');
this.dialFit();
arc.style.transform = 'rotate(' + (span[0] - 90).toFixed(2) + 'deg)';
arc.style.strokeDasharray = (span[1] - span[0]).toFixed(2) + ' 360';
pointer.style.transform = 'rotate(' + ((span[0] + span[1]) / 2).toFixed(2) + 'deg)'; pointer.style.opacity = '';
month(r.month ? r.month - 1 : r.range ? +r.range.start.slice(5, 7) - 1 : -1);
}
specimen(res) {
var box = this.spec;
if (!box) return;
var codeEl = box.querySelector('[data-spec-code]'), legend = box.querySelector('[data-spec-legend]'), cap = box.querySelector('[data-spec-caption]');
var t = this.t, r = res.primary, next;
if (res.status === 'empty') {
next = this.specInit.code; legend.innerHTML = this.specInit.legend; cap.textContent = this.specInit.caption;
} else {
next = (r && r.parts ? r.parts.map(function (p) { return p.chars; }).join('') : (res.clean || '')).slice(0, 10);
cap.textContent = (t.spec || {}).yours || '';
legend.innerHTML = r && r.valid && r.parts ? this.specRows(r) : '<p class="vq-dcc-spec__none">' + esc((t.status || {})[res.status] || '') + '</p>';
}
if (codeEl.textContent !== next) {
codeEl.textContent = next;
codeEl.classList.remove('is-stamp'); void codeEl.offsetWidth; codeEl.classList.add('is-stamp');
}
}
render(res) {
var t = this.t, html = '';
var st = res.status;
this.specimen(res);
this.dialUpdate(res);
if (st === 'empty') { this.out.innerHTML = ''; this.out.hidden = true; return; }
this.out.hidden = false;
var badge = (t.status || {})[st] || st;
html += '<div class="vq-dcc__card vq-dcc__card--' + st + '">';
html += '<p class="vq-dcc__badge"><span class="vq-dcc__dot" aria-hidden="true"></span>' + esc(badge) + '</p>';
if (res.primary && res.primary.valid) {
var r = res.primary;
html += '<h2 class="vq-dcc__head">' + esc(this.headline(r, true)) + '</h2>';
if (r.week && r.range) html += '<p class="vq-dcc__when">' + esc(fmt(t.approx, { from: this.fmtDate(r.range.start), to: this.fmtDate(r.range.end) })) + '</p>';
var place = this.placeText(r);
if (place) html += '<p class="vq-dcc__place">' + esc(place) + '</p>';
html += this.breakdown(r);
html += this.eraLine(r);
var fnote = r.factory && r.factory.known && (t.factoryNotes || {})[r.factoryCode];
if (fnote) html += '<p class="vq-dcc__note">' + esc(fnote) + '</p>';
if (st === 'unknown_factory') html += '<p class="vq-dcc__note">' + esc(fmt(t.msg.unknown_factory, { code: r.factoryCode })) + '</p>' + this.suggestionsHtml(res);
if (r.factory && r.factory.grade === 'C') html += '<p class="vq-dcc__note">' + esc(fmt(t.msg.rare_factory, { code: r.factoryCode })) + '</p>';
if (r.factory && r.factory.grade === 'D') html += '<p class="vq-dcc__note">' + esc(fmt(t.msg.disputed_factory, { code: r.factoryCode })) + '</p>';
if (st === 'inconclusive' || (res.alternatives && res.alternatives.length)) {
var self = this;
html += '<div class="vq-dcc__alts"><p>' + esc(t.altTitle) + '</p><ul>' + (res.alternatives || []).map(function (a) {
return '<li>' + esc(self.headline(a)) + (a.factory ? ' · ' + esc(self.placeText(a)) : '') + ' <span class="vq-dcc__era-inline">(' + esc((t.eras || {})[a.era] || '') + ')</span></li>';
}).join('') + '</ul></div>';
}
html += this.flagsHtml(res);
if (res.normalizedChanged) html += '<p class="vq-dcc__meta">' + esc(fmt(t.readAs, { code: res.clean })) + '</p>';
html += this.checksHtml(res);
html += this.bridgeHtml();
} else {
var key = res.reason ? st + '.' + res.reason : st;
var msg = (t.msg || {})[key] || (t.msg || {})[st] || '';
var p = { code: res.clean, model: res.modelNumber || '' };
if (res.primary && res.primary.factoryCode) p.factory = res.primary.factoryCode;
if (res.primary) { p.unit = res.primary.unitRaw || ''; p.yy = res.primary.yearRaw || ''; p.year = res.primary.year || ''; }
if (res.factory && res.factory.code) p.factory = res.factory.code;
html += '<h2 class="vq-dcc__head">' + esc((t.heads || {})[key] || (t.heads || {})[st] || '') + '</h2>';
if (msg) html += '<p class="vq-dcc__msg">' + esc(fmt(msg, p)) + '</p>';
if (res.primary && res.primary.parts && st === 'impossible') html += this.breakdown(res.primary);
if (st === 'impossible' && t.msg.impossible_caveat) html += '<p class="vq-dcc__note">' + esc(t.msg.impossible_caveat) + '</p>';
if (res.factory) html += '<p class="vq-dcc__place">' + esc(fmt(t.placeKnown, { code: res.factory.code, country: this.countryNames(res.factory.countries) })) + '</p>';
html += this.suggestionsHtml(res);
}
html += '<p class="vq-dcc__disclaimer">' + esc(t.disclaimer) + '</p>';
html += this.actionsHtml(res);
html += '</div>';
this.out.innerHTML = html;
var live = this.querySelector('[data-dcc-live]'), head = this.out.querySelector('.vq-dcc__head');
if (live) { clearTimeout(this._live); var txt = badge + (head ? ': ' + head.textContent : ''); this._live = setTimeout(function () { live.textContent = txt; }, 700); }
}
toast(msg) {
var el = this.out.querySelector('.vq-dcc__toast');
if (!el) return;
el.textContent = msg; el.hidden = false;
clearTimeout(this._toast);
this._toast = setTimeout(function () { el.hidden = true; }, 2400);
}
copy(text, okMsg) {
var self = this;
function fallback() {
var ta = document.createElement('textarea');
ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px';
document.body.appendChild(ta); ta.select();
try { document.execCommand('copy'); self.toast(okMsg); } catch (e) { self.toast(text); }
document.body.removeChild(ta);
}
if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(function () { self.toast(okMsg); }, fallback);
else fallback();
}
onAction(e) {
var btn = e.target.closest('[data-dcc-act]');
if (!btn || !this.last) return;
var act = btn.getAttribute('data-dcc-act'), t = this.t;
if (act === 'try') { this.input.value = btn.getAttribute('data-code'); this.run(true); this.input.focus(); return; }
if (act === 'copy') { this.copy(this.listingText(this.last), t.copied); publish('vq_dcc_action', { action: 'copy_listing' }); return; }
if (act === 'share') {
this.syncUrl(this.last);
var url = location.href;
if (navigator.share) { navigator.share({ title: document.title, url: url }).catch(function () {}); }
else this.copy(url, t.linkCopied);
publish('vq_dcc_action', { action: 'share' });
return;
}
if (act === 'report') publish('vq_dcc_action', { action: 'report' });
}
updateCross() {
if (!this.crossSummary) return;
var parts = [this.modelSel, this.madeSel].filter(function (sel) { return sel && sel.value; }).map(function (sel) { return sel.options[sel.selectedIndex].text; });
this.crossSummary.textContent = parts.join(' · ');
this.crossSummary.hidden = !parts.length;
}
openSheet(dlg) {
if (dlg.open) return;
dlg.classList.remove('is-closing');
if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
}
closeSheet(dlg) {
if (!dlg.open || dlg.classList.contains('is-closing')) return;
var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var finish = function () { dlg.classList.remove('is-closing'); if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); };
if (still) { finish(); return; }
dlg.classList.add('is-closing');
setTimeout(finish, 200);
}
toggleNoCode() {
this.openSheet(this.noCodePanel);
this.renderNoCode();
publish('vq_dcc_action', { action: 'no_code_open' });
}
renderNoCode() {
var sel = this.noCodePanel.querySelector('input[name="dcc_when"]:checked');
var key = sel ? sel.value : '';
this.noCodePanel.querySelectorAll('[data-nc]').forEach(function (el) { el.hidden = el.getAttribute('data-nc') !== key; });
if (key) publish('vq_dcc_action', { action: 'no_code_' + key });
}
}
customElements.define('vq-date-code-checker', VqDateCodeChecker);
document.addEventListener('click', function (e) {
var a = e.target.closest('[data-dcc-cta]');
if (a) publish('vq_dcc_action', { action: 'cta', target: a.getAttribute('data-dcc-cta') });
});
document.addEventListener('click', function (e) {
var b = e.target.closest('[data-dcc-copy]');
if (!b) return;
var text = b.getAttribute('data-dcc-copy'), done = b.getAttribute('data-dcc-copied') || 'OK', orig = b.textContent;
function ok() { b.textContent = done; setTimeout(function () { b.textContent = orig; }, 2000); }
if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(ok, ok);
else { try { window.prompt('', text); } catch (err) { /* nichts */ } }
publish('vq_dcc_action', { action: 'cite_copy' });
});
})();